//アコーディオン-----------------------------------------------------------------------------------------------------------------------------------
// アニメーションの処理を定義した関数
function setupToggleDetailsAnimation() {
  const butbox = document.querySelectorAll(".review-item");
  
  butbox.forEach((elem) => {
    const btn = elem.querySelector(".show-more");
    const text = elem.querySelector(".review-item-text.wrapper");
    
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      
      // 現在の状態をチェック
      if (!elem.classList.contains("is-shown")) {
        // 表示状態にする
        elem.classList.add("is-shown");
   
      } else {
        // 非表示状態にする
        elem.classList.remove("is-shown");
       
      }
    });
  });

  const details = document.querySelectorAll(".faq-item-wrap details");

  // 上記で取得したそれぞれの要素に対して以下を実行（elem は各 details 要素）
  details.forEach((elem) => {
    // summary 要素
    const summary = elem.querySelector("summary");
    // details-content クラスを指定した要素
    const content = elem.querySelector(".faq-item-text-wrap");

    // summary 要素にクリックイベントのリスナを設定
    summary.addEventListener("click", (e) => {
      e.preventDefault();
      if (elem.open) {
        // details-content クラスを指定した要素を閉じるアニメーション
        const closeDetails = content.animate(
          {
            opacity: [1, 0],
            height: [content.offsetHeight + "px", 0],
          },
          {
            duration: 300,
            easing: "ease-in-out",
          }
        );
        //閉じる際の ::after（縦棒）のアニメーション
        const rotate2 = summary.animate(
          {
            rotate: ["90deg", "0deg"],
          },
          {
            duration: 300,
            pseudoElement: "::after",
            easing: "ease-out",
            fill: "forwards",
          }
        );
        closeDetails.onfinish = () => {
          elem.removeAttribute("open");
        };
      } else {
        elem.setAttribute("open", "true");
        // details-content クラスを指定した要素を開くアニメーション
        const openDetails = content.animate(
          {
            opacity: [0, 1],
            height: [0, content.offsetHeight + "px"],
          },
          {
            duration: 300,
            easing: "ease-in-out",
          }
        );
        //開く際の ::after（縦棒）のアニメーション
        const rotate2 = summary.animate(
          {
            rotate: ["0deg", "90deg"],
          },
          {
            duration: 300,
            pseudoElement: "::after",
            easing: "ease-out",
            fill: "forwards",
          }
        );
      }
    });
  });

}
setupToggleDetailsAnimation();

//スクロール表示アニメーション-----------------------------------------------------------------------------------------------------------------------------------
ScrollReveal().reveal(".animate", {
  duration: 700,
  easing: "ease",
  origin: "bottom",
  distance: "20px",
  reset: false,
});
